// Escalera visual móvil: 4 estados por tipo + líneas honestas para
// parciales/vencidas/compensadas. La card nunca miente: los estados
// auxiliares se explican en línea secundaria, no como badge.
import { formatCurrency, formatDateShort } from "./format";

const CLS = {
  slate: "bg-slate-100 text-slate-600",
  amber: "bg-amber-100 text-amber-700",
  blue: "bg-blue-100 text-blue-700",
  emerald: "bg-emerald-100 text-emerald-700",
};

function daysOverdue(due, today) {
  const d = new Date(`${String(due).slice(0, 10)}T00:00:00`);
  return Math.floor((today - d) / 86400000);
}

function isOverdue(inv, today) {
  if (!inv.due_date || inv.status === "draft") return false;
  if (["paid", "overpaid", "compensated"].includes(inv.payment_status)) return false;
  return daysOverdue(inv.due_date, today) > 0;
}

export function invoiceStatusMeta(inv, kind, today = new Date()) {
  let label, cls, line = null, lineTone = null;
  const ps = inv.payment_status;
  if (kind === "emitted") {
    if (ps === "paid" || ps === "overpaid") { label = "Cobrada"; cls = CLS.emerald; }
    else if (ps === "compensated") { label = "Compensada"; cls = CLS.slate; }
    else if (inv.status === "registered") { label = "Contabilizada"; cls = CLS.blue; }
    else if (inv.status === "issued" || inv.status === "emitted") { label = "Emitida"; cls = CLS.amber; }
    else { label = "Borrador"; cls = CLS.slate; }
  } else {
    if (ps === "paid" || ps === "overpaid") { label = "Pagada"; cls = CLS.emerald; }
    else if (inv.status === "accounted") { label = "Contabilizada"; cls = CLS.blue; }
    else { label = "Pendiente"; cls = CLS.amber; }
  }
  if (ps === "overpaid") { line = "Sobrecobrada — revísala en escritorio"; lineTone = "amber"; }
  if (ps === "partial") {
    const collected = kind === "emitted" ? (inv.amount_collected ?? 0) : (inv.amount_paid ?? 0);
    const verbo = kind === "emitted" ? "Cobrada" : "Pagada";
    line = `${verbo} parcialmente — faltan ${formatCurrency((inv.total_amount ?? 0) - collected)}`;
    lineTone = "amber";
  }
  if (kind === "emitted" && isOverdue(inv, today)) {
    line = `Vencida desde el ${formatDateShort(inv.due_date)} · hace ${daysOverdue(inv.due_date, today)} días`;
    lineTone = "rose";
  }
  return { label, cls, line, lineTone };
}

export function installmentLine(inv) {
  const st = inv.installment_status;
  if (!st || !Array.isArray(st.installments) || st.installments.length === 0) return null;
  const paid = st.installments.filter((p) => p.status === "paid").length;
  let out = `${paid}/${st.installments.length} plazos cobrados`;
  if (st.next_due) out += ` · próximo: ${formatDateShort(st.next_due)} (${formatCurrency(st.next_due_amount ?? 0)})`;
  return out;
}
